export default __webpack_public_path__ + "static/media/image-04.09b72f4f.jpg";